import { Link, useNavigate } from 'react-router';

import { RequestChangesParty } from 'src/containers/SoftwareEscrow/RequestChanges';
import { Button } from '@/components/ui/button';
import { PartySuggestChangesContextProvider, usePartySuggestChanges } from 'src/context/suggest-changes';
import { EscrowPartyTypeEnum, EscrowStatusEnum } from 'src/graphql/schema';
import {
  SoftwareOnboardingLayout,
  SoftwareOnboardingHeader,
  SoftwareOnboardingMain,
  SoftwareOnboardingFooter,
} from 'src/components/SoftwareOnboarding';
import { useSoftwareEscrow } from 'src/context/software-escrow';
import { ExitAlertDialog } from 'src/pages/SoftwareEscrowRequestChanges/ui';

const Content = () => {
  const {
    softwareEscrow: { id, status },
  } = useSoftwareEscrow();
  const { isSendSuggestionsEnabled, setSubmitChangesDialog, partyType } = usePartySuggestChanges();
  const navigate = useNavigate();

  const onSubmitChanges = () => setSubmitChangesDialog(true);

  const onDiscardChanges = () => navigate(`/software-escrows/${id}/settings/${partyType}`);

  return (
    <SoftwareOnboardingLayout>
      <SoftwareOnboardingHeader justify="end">
        <ExitAlertDialog onDiscard={onDiscardChanges} />
      </SoftwareOnboardingHeader>
      <SoftwareOnboardingMain
        subtitle="Request changes to:"
        title="Depositor information and representatives"
        description="Check your organization details and add the key points of contact and authorized signatories for this escrow."
        noteText={
          status === EscrowStatusEnum.Onboarding && (
            <>
              Once all parties approve the escrow, we’ll send e-signature requests via DropBox Sign to the designated
              signatories to make the agreement legally binding.
              <br />
              Need a different signing method or a hardcopy agreement?{' '}
              <Link to="/help-resources/contact-us" className="underline!">
                Contact us
              </Link>
              .
            </>
          )
        }
        classes={{ subtitle: 'font-medium' }}
      >
        <div className="container mx-auto grow-1 md:overflow-hidden">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:h-full">
            <RequestChangesParty />
          </div>
        </div>
      </SoftwareOnboardingMain>
      <SoftwareOnboardingFooter justify="end">
        <Button disabled={!isSendSuggestionsEnabled} onClick={onSubmitChanges}>
          Submit changes
        </Button>
      </SoftwareOnboardingFooter>
    </SoftwareOnboardingLayout>
  );
};

const SoftwareEscrowRequestChangesDepositor = () => {
  return (
    <PartySuggestChangesContextProvider partyType={EscrowPartyTypeEnum.Depositor}>
      <Content />
    </PartySuggestChangesContextProvider>
  );
};

export default SoftwareEscrowRequestChangesDepositor;
